module.exports = __webpack_public_path__ + "assets/img/sy-5.e42b49d2.png";